export const imageLoader = async (src: string): Promise<HTMLImageElement> => {
  const img = new Image();
  img.src = src;
  await new Promise((resolve) => {
    img.onload = () => resolve(img);
  });
  return img;
};
